const styles = (theme, props) => ({
  drawerPaper: {
    width: props.isMobile ? '100%' : '30%',
    top: props.isMobile ? (props.isComposeView ? '0px' : '75px') : '126px',
    overflowY: 'auto',
    position: 'relative',
  },
  fullList: {
    width: 'auto',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/ui/library/Drawer/styles.js